import { RJSFSchema } from "@rjsf/utils";

// Agent Data Intake Form Schema - EXACT LABELS FROM ORIGINAL FORM
export const agentIntakeSchema: RJSFSchema = {
  title: "",
  "x-logo": "../assets/657507_tmpl_head_60db3e2024ea6.png",
  type: "object",
  required: ["agentType"],
  properties: {
    agentType: {
      type: "string",
      title: "Please select one of the following:",
      enum: ["existing", "new"],
    },

    // Primary Contact Information (always visible)
    contactEmail: {
      type: "string",
      format: "email",
      title: "Your email address",
    },
    contactPhone: {
      type: "string",
      title: "Best contact phone number",
    },
    contactAgency: {
      type: "string",
      title: "What agency are you with?",
    },
  },
  dependencies: {
    agentType: {
      oneOf: [
        // EXISTING AGENT PATH
        {
          properties: {
            agentType: { enum: ["existing"] },

            updateType: {
              type: "array",
              title: "I need to:",
              description: "Select all that apply. You can update multiple items in one submission.",
              items: {
                type: "string",
                oneOf: [
                  {
                    const: "agent_license",
                    title: "Update Agent License",
                  },
                  {
                    const: "agency_license",
                    title: "Update Agency License",
                  },
                  {
                    const: "eo",
                    title: "Update E&O",
                  },
                  {
                    const: "new_carrier",
                    title: "Get Appointed with New Carrier",
                  },
                  {
                    const: "ach",
                    title: "Update my Commissions ACH",
                  },
                ],
              },
              uniqueItems: true,
              minItems: 1,
            },

            // Agent Information
            optimedAgentId: {
              type: "string",
              title: "Optimed Agent ID Number - PLEASE COPY AND PASTE THE AGENT ID NUMBER FROM THE EMAIL ",
              maxLength: 90,
            },

            // Licensed Agent Legal Name
            agentFirstName: {
              type: "string",
              title: "Licensed Agent's Legal First Name",
            },
            agentMiddleName: {
              type: "string",
              title: "Licensed Agent's Legal Middle Name",
            },
            agentLastName: {
              type: "string",
              title: "Licensed Agent's Legal Last Name",
            },
            agentSuffix: {
              type: "string",
              title: "Suffix",
            },

            // Contact Information
            existingContactEmail: {
              type: "string",
              format: "email",
              title: "Your email address",
            },
            existingContactPhone: {
              type: "string",
              title: "Best contact phone number",
            },
            existingContactAgency: {
              type: "string",
              title: "What agency are you with?",
            },
            existingAgentEmail: {
              type: "string",
              format: "email",
              title: "Licensed Agent Email Address",
            },
            agentNPN: {
              type: "string",
              title: "Licensed Agent National Producer Number (NPN) ",
              pattern: "^[0-9]+$",
            },
            agentSSN: {
              type: "string",
              title: "Licensed Agent's Social Security Number",
              pattern: "^[0-9]{3}-?[0-9]{2}-?[0-9]{4}$",
            },
            agentDOB: {
              type: "string",
              format: "date",
              title: "Licensed Agent's Date of Birth",
            },

            // Update fields that appear based on selections
            // Agent License Update Fields
            updateAgentLicenseNumber: {
              type: "string",
              title: "Agent License #",
            },
            updateStateOfAgentLicense: {
              type: "string",
              title: "State of Agent License",
              enum: [
                "AK",
                "AL",
                "AR",
                "AZ",
                "CA",
                "CO",
                "CT",
                "DC",
                "DE",
                "FL",
                "GA",
                "HI",
                "IA",
                "ID",
                "IL",
                "IN",
                "KS",
                "KY",
                "LA",
                "MA",
                "MD",
                "ME",
                "MI",
                "MN",
                "MO",
                "MS",
                "MT",
                "NC",
                "ND",
                "NE",
                "NH",
                "NJ",
                "NM",
                "NV",
                "NY",
                "OH",
                "OK",
                "OR",
                "PA",
                "RI",
                "SC",
                "SD",
                "TN",
                "TX",
                "UT",
                "VA",
                "VT",
                "WA",
                "WI",
                "WV",
                "WY",
              ],
            },
            updateDateAgentLicenseEffective: {
              type: "string",
              format: "date",
              title: "Date Agent License is Effective",
            },
            updateDateAgentLicenseExpires: {
              type: "string",
              format: "date",
              title: "Date Agent License Expires",
            },
            updateAgentLicenseDocument: {
              type: "string",
              title: "Agent License Document",
              format: "data-url",
            },

            // Agency License Update Fields
            updateAgencyLicenseNumber: {
              type: "string",
              title: "Agency License Number",
              maxLength: 90,
            },
            updateStateOfAgencyLicense: {
              type: "string",
              title: "State of Agency License ",
              enum: [
                "AK",
                "AL",
                "AR",
                "AZ",
                "CA",
                "CO",
                "CT",
                "DC",
                "DE",
                "FL",
                "GA",
                "HI",
                "IA",
                "ID",
                "IL",
                "IN",
                "KS",
                "KY",
                "LA",
                "MA",
                "MD",
                "ME",
                "MI",
                "MN",
                "MO",
                "MS",
                "MT",
                "NC",
                "ND",
                "NE",
                "NH",
                "NJ",
                "NM",
                "NV",
                "NY",
                "OH",
                "OK",
                "OR",
                "PA",
                "RI",
                "SC",
                "SD",
                "TN",
                "TX",
                "UT",
                "VA",
                "VT",
                "WA",
                "WI",
                "WV",
                "WY",
              ],
            },
            updateDateAgencyLicenseEffective: {
              type: "string",
              format: "date",
              title: "Date Agency License is Effective",
            },
            updateDateAgencyLicenseExpires: {
              type: "string",
              format: "date",
              title: "Date Agency License Expires",
            },
            updateAgencyLicenseDocument: {
              type: "string",
              title: "Agency License Document",
              format: "data-url",
            },

            // E&O Update Fields
            updateEOPolicyNumber: {
              type: "string",
              title: "E&O Policy Number",
            },
            updateDateEOEffective: {
              type: "string",
              format: "date",
              title: "Date E&O is Effective",
            },
            updateDateEOExpires: {
              type: "string",
              format: "date",
              title: "Date E&O Expires",
            },
            updateEODocument: {
              type: "string",
              title: "E&O Document - I attest that I am an insured under the E&O certificate and/or policy attached",
              format: "data-url",
            },

            // New Carrier Appointment Fields
            newCarrierLicensedAgentName: {
              type: "object",
              title: "Licensed Agent Name",
              properties: {
                firstName: { type: "string", title: "First Name" },
                lastName: { type: "string", title: "Last Name" },
              },
              required: ["firstName", "lastName"],
            },
            newCarrierLicensedAgentNPN: {
              type: "string",
              title: "Licensed Agent National Producer Number (NPN) ",
            },

            // Consent text (display only)
            pdbConsent: {
              type: "null",
              title:
                "By completing this form, I hereby give consent to OptiMed running Producer Data Base (PDB) reports to validate my state licenses.",
            },

            // ACH Instructions (display only)
            achInstructions: {
              type: "null",
              title: "",
              description:
                "Please continue to the next page for the ACH form and select Direct Deposit for Commissions",
            },
          },
          required: [
            "updateType",
            "agentFirstName",
            "agentLastName",
            "existingContactEmail",
            "existingContactPhone",
            "existingContactAgency",
            "existingAgentEmail",
          ],
        },

        // NEW AGENT PATH
        {
          properties: {
            agentType: { enum: ["new"] },

            // Agent Information
            optimedAgentId: {
              type: "string",
              title: "Optimed Agent ID Number - PLEASE COPY AND PASTE THE AGENT ID NUMBER FROM THE EMAIL ",
              maxLength: 90,
            },

            // Group Information
            carrierOfProduct: {
              type: "string",
              title: "What is the carrier of the product sold?",
              enum: [
                "zurich",
                "selffunded",
                "everest",
                "breckpoint",
                "nationwide",
                "chubb",
                "markel",
                "shelterpoint",
                "providence",
                "principal",
                "oldrepublic",
              ],
            },

            groupName: {
              type: "string",
              title: "Name of Group Sold",
            },

            stateGroupSoldIn: {
              type: "string",
              title: "State Group was Sold In",
              enum: [
                "AK",
                "AL",
                "AR",
                "AZ",
                "CA",
                "CO",
                "CT",
                "DC",
                "DE",
                "FL",
                "GA",
                "HI",
                "IA",
                "ID",
                "IL",
                "IN",
                "KS",
                "KY",
                "LA",
                "MA",
                "MD",
                "ME",
                "MI",
                "MN",
                "MO",
                "MS",
                "MT",
                "NC",
                "ND",
                "NE",
                "NH",
                "NJ",
                "NM",
                "NV",
                "NY",
                "OH",
                "OK",
                "OR",
                "PA",
                "RI",
                "SC",
                "SD",
                "TN",
                "TX",
                "UT",
                "VA",
                "VT",
                "WA",
                "WI",
                "WV",
                "WY",
              ],
            },

            groupNumber: {
              type: "string",
              title: "Group Number (if assigned)",
            },

            isLicensedAgent: {
              type: "string",
              title: "Are you the Licensed Agent?",
              description:
                "Thank you for choosing OptiMed! Please complete and submit this online form. Be ready to upload required documents to maintain an active appointment with OptiMedHealth and our Carriers.",
              enum: ["licensed", "filling"],
            },

            // Form Filler Information (if not licensed agent)
            fillerName: {
              type: "object",
              title: "Your Name",
              properties: {
                firstName: { type: "string", title: "First Name" },
                lastName: { type: "string", title: "Last Name" },
              },
              required: ["firstName", "lastName"],
            },
            fillerEmail: {
              type: "string",
              format: "email",
              title: "Your email address",
            },
            fillerPhone: {
              type: "string",
              title: "Your Phone",
            },

            // Licensed Agent Legal Name
            agentFirstName: {
              type: "string",
              title: "Licensed Agent's Legal First Name",
            },
            agentMiddleName: {
              type: "string",
              title: "Licensed Agent's Legal Middle Name",
            },
            agentLastName: {
              type: "string",
              title: "Licensed Agent's Legal Last Name",
            },
            agentSuffix: {
              type: "string",
              title: "Suffix",
            },
            agentPreferredName: {
              type: "string",
              title: "Licensed Agent's Preferred Name",
            },

            // Licensed Agent NPN
            agentNPN: {
              type: "string",
              title: "Licensed Agent National Producer Number (NPN) ",
              pattern: "^[0-9]+$",
            },

            // Licensed Agent Contact
            agentEmail: {
              type: "string",
              format: "email",
              title: "Licensed Agent Email Address",
            },
            agentOfficePhone: {
              type: "string",
              title: "Licensed Agent's Office Phone",
            },
            agentCell: {
              type: "string",
              title: "Licensed Agent's Cell",
            },
            agentTitle: {
              type: "string",
              title: "Licensed Agent's Title",
            },

            // Demographics
            agentSex: {
              type: "string",
              title: "Licensed Agent's Sex",
              enum: ["male", "female"],
            },
            agentSSN: {
              type: "string",
              title: "Licensed Agent's Social Security Number",
              pattern: "^[0-9]{3}-?[0-9]{2}-?[0-9]{4}$",
            },
            agentDOB: {
              type: "string",
              format: "date",
              title: "Licensed Agent's Date of Birth",
            },

            // Licensed Agent Home Address
            agentHomeAddress: {
              type: "string",
              title: "Licensed Agent's Home Street Address",
            },
            agentHomeAddress2: {
              type: "string",
              title: "Licensed Agent's Home Street Address Line 2",
            },
            agentHomeCity: {
              type: "string",
              title: "Licensed Agent's Home City ",
            },
            agentHomeState: {
              type: "string",
              title: "Licensed Agent's Home State",
              enum: [
                "AL",
                "AK",
                "AZ",
                "AR",
                "CA",
                "CO",
                "CT",
                "DE",
                "DC",
                "FL",
                "GA",
                "HI",
                "ID",
                "IL",
                "IN",
                "IA",
                "KS",
                "KY",
                "LA",
                "ME",
                "MD",
                "MA",
                "MI",
                "MN",
                "MS",
                "MO",
                "MT",
                "NE",
                "NV",
                "NH",
                "NJ",
                "NM",
                "NY",
                "NC",
                "ND",
                "OH",
                "OK",
                "OR",
                "PA",
                "RI",
                "SC",
                "SD",
                "TN",
                "TX",
                "UT",
                "VT",
                "VA",
                "WA",
                "WV",
                "WI",
                "WY",
              ],
            },
            agentHomeZip: {
              type: "string",
              title: "Licensed Agent's Home Zip",
              pattern: "^[0-9]{5}(-[0-9]{4})?$",
            },

            // Agency Ownership
            isAgencyOwner: {
              type: "string",
              title: "Is the licensed agent  the Owner of the Agency?",
              enum: ["yes", "no", "individual"],
            },

            commissionsToAgency: {
              type: "string",
              title: "Will commissions be payable to an Agency?",
              enum: ["yes", "no"],
            },

            // Agency Owner Information
            ownerFirstName: {
              type: "string",
              title: "Agency Owner First Name",
            },
            ownerLastName: {
              type: "string",
              title: "Agency Owner Last Name",
            },
            ownerEmail: {
              type: "string",
              format: "email",
              title: "Email of the Agency Owner",
            },

            // Agency Information
            agencyName: {
              type: "string",
              title: "What is your agency's name?",
            },
            agencyNPN: {
              type: "string",
              title: "Agency National Producer Number (NPN)",
              pattern: "^[0-9]+$",
            },
            hasDBA: {
              type: "string",
              title: "Does your agency have a DBA?",
              enum: ["yes", "no"],
            },
            dbaName: {
              type: "string",
              title: "DBA Name",
            },
            taxId: {
              type: "string",
              title: "Tax ID Number",
            },
            agencyAddress: {
              type: "string",
              title: "Agency's Street Address",
            },
            agencyAddress2: {
              type: "string",
              title: "Agency's Street Address Line 2",
            },
            agencyCity: {
              type: "string",
              title: "Agency's City",
            },
            agencyState: {
              type: "string",
              title: "Agency's State",
              enum: [
                "AK",
                "AL",
                "AR",
                "AZ",
                "CA",
                "CO",
                "CT",
                "DC",
                "DE",
                "FL",
                "GA",
                "HI",
                "IA",
                "ID",
                "IL",
                "IN",
                "KS",
                "KY",
                "LA",
                "MA",
                "MD",
                "ME",
                "MI",
                "MN",
                "MO",
                "MS",
                "MT",
                "NC",
                "ND",
                "NE",
                "NH",
                "NJ",
                "NM",
                "NV",
                "NY",
                "OH",
                "OK",
                "OR",
                "PA",
                "RI",
                "SC",
                "SD",
                "TN",
                "TX",
                "UT",
                "VA",
                "VT",
                "WA",
                "WI",
                "WV",
                "WY",
              ],
            },
            agencyZip: {
              type: "string",
              title: "Agency's Zip",
              pattern: "^[0-9]{5}(-[0-9]{4})?$",
            },
            operatingAs: {
              type: "string",
              title: "Operating as",
              enum: ["corporation", "partnership", "individual", "sole_proprietorship"],
            },

            // Background Questions - EXACT LABELS FROM ORIGINAL FORM
            backgroundQ1: {
              type: "string",
              title:
                "1. Do you have delinquent unpaid debts exceeding, in total, $10,000? (Add together delinquent consumer debt, tax liens, loans, child support payments, alimony payments, civil judgements and other delinquent debt.)",
              description:
                "Please answer the following background questions truthfully. If you answer 'Yes' to any question, you'll be asked to provide an explanation and supporting documents.",
              enum: ["yes", "no"],
            },
            backgroundQ1Explanation: {
              type: "string",
              title: "1. Please provide an explanation:",
            },
            backgroundQ1Docs: {
              type: "string",
              title: "1. Please attach supporting documents",
              format: "data-url",
            },

            backgroundQ2: {
              type: "string",
              title:
                "2. With the exception of situations specific to continuing education, have you ever been the subject of an administrative proceeding regarding any professional or occupational license that resulted in disciplinary action?",
              enum: ["yes", "no"],
            },
            backgroundQ2Explanation: {
              type: "string",
              title: "2. Please provide an explanation:",
            },
            backgroundQ2Docs: {
              type: "string",
              title: "2. Please attach supporting documents",
              format: "data-url",
            },

            backgroundQ3: {
              type: "string",
              title:
                "3. Have you filed for, or been discharged from any bankruptcy (including personal bankruptcy), insolvency or assignment for the benefit of creditors with a filing or discharge date, whichever is later, in the last 5 years?",
              enum: ["yes", "no"],
            },
            backgroundQ3Explanation: {
              type: "string",
              title: "3. Please provide an explanation:",
            },
            backgroundQ3Docs: {
              type: "string",
              title: "4. Please attach supporting documents",
              format: "data-url",
            },

            backgroundQ4: {
              type: "string",
              title:
                "4. With the exception of situations specific to continuing education, has your insurance license ever been suspended or revoked by any regulatory agency or have you ever surrendered your insurance license or been fined, penalized, sanctioned or subject to any other disciplinary action by a state or federal regulatory agency, including any current investigations by a regulatory agency as a result of your activities in the business of insurance?",
              enum: ["yes", "no"],
            },
            backgroundQ4Explanation: {
              type: "string",
              title: "4. Please provide an explanation:",
            },
            backgroundQ4Docs: {
              type: "string",
              title: "4. Please attach supporting documents",
              format: "data-url",
            },

            backgroundQ5: {
              type: "string",
              title:
                "5. Have you ever had an insurance agency contract or any other business relationship with an insurance company terminated for any alleged misconduct?",
              enum: ["yes", "no"],
            },
            backgroundQ5Explanation: {
              type: "string",
              title: "5. Please provide an explanation:",
            },
            backgroundQ5Docs: {
              type: "string",
              title: "5. Please attach supporting documents",
              format: "data-url",
            },

            backgroundQ6: {
              type: "string",
              title:
                "6. Are you currently under investigation for or have you ever been convicted of, plead guilty or no contest to, any misdemeanor involving dishonesty or breach of trust or any felony.?",
              enum: ["yes", "no"],
            },
            backgroundQ6Explanation: {
              type: "string",
              title: "6. Please provide an explanation:",
            },
            backgroundQ6Docs: {
              type: "string",
              title: "6. Please attach supporting documents",
              format: "data-url",
            },

            backgroundQ7: {
              type: "string",
              title:
                "7. Are you now the subject of any complaint, investigation or proceeding that could result in a yes answer to any of the previous questions?",
              enum: ["yes", "no"],
            },
            backgroundQ7Explanation: {
              type: "string",
              title: "7. Please provide an explanation:",
            },
            backgroundQ7Docs: {
              type: "string",
              title: "7. Please attach supporting documents",
              format: "data-url",
            },

            // Licensing Contact Information
            contactPerson: {
              type: "string",
              title: "Contact Person to provide updated licensing information",
            },
            contactEmail: {
              type: "string",
              format: "email",
              title: "Email of Contact Person to provide updated licensing information ",
            },

            // Required Documents - Agent License
            agentLicenseNumber: {
              type: "string",
              title: "Agent License #",
            },
            stateOfAgentLicense: {
              type: "string",
              title: "State of Agent License",
              enum: [
                "AK",
                "AL",
                "AR",
                "AZ",
                "CA",
                "CO",
                "CT",
                "DC",
                "DE",
                "FL",
                "GA",
                "HI",
                "IA",
                "ID",
                "IL",
                "IN",
                "KS",
                "KY",
                "LA",
                "MA",
                "MD",
                "ME",
                "MI",
                "MN",
                "MO",
                "MS",
                "MT",
                "NC",
                "ND",
                "NE",
                "NH",
                "NJ",
                "NM",
                "NV",
                "NY",
                "OH",
                "OK",
                "OR",
                "PA",
                "RI",
                "SC",
                "SD",
                "TN",
                "TX",
                "UT",
                "VA",
                "VT",
                "WA",
                "WI",
                "WV",
                "WY",
              ],
            },
            dateAgentLicenseEffective: {
              type: "string",
              format: "date",
              title: "Date Agent License is Effective",
            },
            dateAgentLicenseExpires: {
              type: "string",
              format: "date",
              title: "Date Agent License Expires",
            },
            agentLicenseDocument: {
              type: "string",
              title: "Agent License Document",
              format: "data-url",
            },

            // Agency License
            agencyLicenseNumber: {
              type: "string",
              title: "Agency License Number",
              maxLength: 90,
            },
            stateOfAgencyLicense: {
              type: "string",
              title: "State of Agency License ",
              enum: [
                "AK",
                "AL",
                "AR",
                "AZ",
                "CA",
                "CO",
                "CT",
                "DC",
                "DE",
                "FL",
                "GA",
                "HI",
                "IA",
                "ID",
                "IL",
                "IN",
                "KS",
                "KY",
                "LA",
                "MA",
                "MD",
                "ME",
                "MI",
                "MN",
                "MO",
                "MS",
                "MT",
                "NC",
                "ND",
                "NE",
                "NH",
                "NJ",
                "NM",
                "NV",
                "NY",
                "OH",
                "OK",
                "OR",
                "PA",
                "RI",
                "SC",
                "SD",
                "TN",
                "TX",
                "UT",
                "VA",
                "VT",
                "WA",
                "WI",
                "WV",
                "WY",
              ],
            },
            dateAgencyLicenseEffective: {
              type: "string",
              format: "date",
              title: "Date Agency License is Effective",
            },
            dateAgencyLicenseExpires: {
              type: "string",
              format: "date",
              title: "Date Agency License Expires",
            },
            agencyLicenseDocument: {
              type: "string",
              title: "Agency License Document",
              format: "data-url",
            },

            // E&O Certificate
            eoPolicyNumber: {
              type: "string",
              title: "E&O Policy Number",
            },
            dateEOEffective: {
              type: "string",
              format: "date",
              title: "Date E&O is Effective",
            },
            dateEOExpires: {
              type: "string",
              format: "date",
              title: "Date E&O Expires",
            },
            eoDocument: {
              type: "string",
              title: "E&O Document - I attest that I am an insured under the E&O certificate and/or policy attached",
              format: "data-url",
            },

            // Consent text (display only)
            pdbConsent: {
              type: "null",
              title:
                "By completing this form, I hereby give consent to OptiMed running Producer Data Base (PDB) reports to validate my state licenses.",
            },

            // ACH Instructions (display only)
            achInstructions: {
              type: "null",
              title: "",
              description:
                "Please continue to the next page for the ACH form and select Direct Deposit for Commissions",
            },
          },
          required: [
            "isLicensedAgent",
            "agentFirstName",
            "agentLastName",
            "agentPreferredName",
            "agentNPN",
            "agentEmail",
            "agentOfficePhone",
            "agentCell",
            "agentTitle",
            "agentSex",
            "agentSSN",
            "agentDOB",
            "agentHomeAddress",
            "agentHomeCity",
            "agentHomeState",
            "agentHomeZip",
            "isAgencyOwner",
            "commissionsToAgency",
          ],
          allOf: [
            {
              if: {
                properties: {
                  isAgencyOwner: { const: "no" },
                },
              },
              then: {
                required: ["ownerFirstName", "ownerLastName", "ownerEmail"],
              },
            },
            {
              if: {
                properties: {
                  commissionsToAgency: { const: "yes" },
                },
              },
              then: {
                required: [
                  "agencyName",
                  "agencyNPN",
                  "hasDBA",
                  "taxId",
                  "agencyAddress",
                  "agencyCity",
                  "agencyState",
                  "agencyZip",
                  "operatingAs",
                ],
              },
            },
            {
              if: {
                properties: {
                  commissionsToAgency: { const: "yes" },
                  hasDBA: { const: "yes" },
                },
              },
              then: {
                required: ["dbaName"],
              },
            },
          ],
        },
      ],
    },
  },
};
